// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file chat/chat_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { E2eeAddParticipant, E2eeCommit } from '../encryption/encryption_model_pb';
import { file_encryption_encryption_model } from '../encryption/encryption_model_pb';
import type { Chat_Type } from './chat_model_pb';
import { file_chat_chat_model } from './chat_model_pb';

/**
 * Describes the file chat/chat_requests.proto.
 */
export const file_chat_chat_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_chat_chat_model, file_encryption_encryption_model]
  );

/**
 * @generated from message com.gem.bff.contract.ChatsPageRequest
 */
export type ChatsPageRequest = Message<'com.gem.bff.contract.ChatsPageRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatsPageRequest.
 * Use `create(ChatsPageRequestSchema)` to create a new message.
 */
export const ChatsPageRequestSchema: GenMessage<ChatsPageRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 0);

/**
 * @generated from message com.gem.bff.contract.ChatsUpdatesRequest
 */
export type ChatsUpdatesRequest = Message<'com.gem.bff.contract.ChatsUpdatesRequest'> & {
  /**
   * @generated from field: repeated int64 chatIds = 1;
   */
  chatIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.ChatsUpdatesRequest.
 * Use `create(ChatsUpdatesRequestSchema)` to create a new message.
 */
export const ChatsUpdatesRequestSchema: GenMessage<ChatsUpdatesRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 1);

/**
 * @generated from message com.gem.bff.contract.ChatsByIdsRequest
 */
export type ChatsByIdsRequest = Message<'com.gem.bff.contract.ChatsByIdsRequest'> & {
  /**
   * @generated from field: repeated int64 chatIds = 1;
   */
  chatIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.ChatsByIdsRequest.
 * Use `create(ChatsByIdsRequestSchema)` to create a new message.
 */
export const ChatsByIdsRequestSchema: GenMessage<ChatsByIdsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 2);

/**
 * @generated from message com.gem.bff.contract.CreateChatRequest
 */
export type CreateChatRequest = Message<'com.gem.bff.contract.CreateChatRequest'> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * @generated from field: com.gem.bff.contract.Chat.Type type = 3;
   */
  type: Chat_Type;

  /**
   * @generated from field: repeated int64 participants = 4;
   */
  participants: bigint[];

  /**
   * @generated from field: repeated int64 admins = 5;
   */
  admins: bigint[];

  /**
   * @generated from field: optional string deepLinkAlias = 6;
   */
  deepLinkAlias?: string;

  /**
   * @generated from field: optional string avatarUrl = 7;
   */
  avatarUrl?: string;
};

/**
 * Describes the message com.gem.bff.contract.CreateChatRequest.
 * Use `create(CreateChatRequestSchema)` to create a new message.
 */
export const CreateChatRequestSchema: GenMessage<CreateChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 3);

/**
 * @generated from message com.gem.bff.contract.CreateSecretChatRequest
 */
export type CreateSecretChatRequest = Message<'com.gem.bff.contract.CreateSecretChatRequest'> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * @generated from field: optional string avatarUrl = 3;
   */
  avatarUrl?: string;

  /**
   * @generated from field: repeated com.gem.bff.contract.E2eeAddParticipant participants = 4;
   */
  participants: E2eeAddParticipant[];

  /**
   * @generated from field: repeated com.gem.bff.contract.E2eeAddParticipant admins = 5;
   */
  admins: E2eeAddParticipant[];

  /**
   * @generated from field: com.gem.bff.contract.E2eeCommit commit = 6;
   */
  commit?: E2eeCommit;
};

/**
 * Describes the message com.gem.bff.contract.CreateSecretChatRequest.
 * Use `create(CreateSecretChatRequestSchema)` to create a new message.
 */
export const CreateSecretChatRequestSchema: GenMessage<CreateSecretChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 4);

/**
 * @generated from message com.gem.bff.contract.CreateSecretChatAccessRequestRequest
 */
export type CreateSecretChatAccessRequestRequest =
  Message<'com.gem.bff.contract.CreateSecretChatAccessRequestRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.CreateSecretChatAccessRequestRequest.
 * Use `create(CreateSecretChatAccessRequestRequestSchema)` to create a new message.
 */
export const CreateSecretChatAccessRequestRequestSchema: GenMessage<CreateSecretChatAccessRequestRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 5);

/**
 * @generated from message com.gem.bff.contract.GetActiveSecretChatAccessRequestsRequest
 */
export type GetActiveSecretChatAccessRequestsRequest =
  Message<'com.gem.bff.contract.GetActiveSecretChatAccessRequestsRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.GetActiveSecretChatAccessRequestsRequest.
 * Use `create(GetActiveSecretChatAccessRequestsRequestSchema)` to create a new message.
 */
export const GetActiveSecretChatAccessRequestsRequestSchema: GenMessage<GetActiveSecretChatAccessRequestsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 6);

/**
 * @generated from message com.gem.bff.contract.AcceptSecretChatAccessRequestsRequest
 */
export type AcceptSecretChatAccessRequestsRequest =
  Message<'com.gem.bff.contract.AcceptSecretChatAccessRequestsRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.E2eeCommit commit = 2;
     */
    commit?: E2eeCommit;

    /**
     * @generated from field: repeated com.gem.bff.contract.E2eeAddParticipant participant = 3;
     */
    participant: E2eeAddParticipant[];
  };

/**
 * Describes the message com.gem.bff.contract.AcceptSecretChatAccessRequestsRequest.
 * Use `create(AcceptSecretChatAccessRequestsRequestSchema)` to create a new message.
 */
export const AcceptSecretChatAccessRequestsRequestSchema: GenMessage<AcceptSecretChatAccessRequestsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 7);

/**
 * @generated from message com.gem.bff.contract.DeclineSecretChatAccessRequestsRequest
 */
export type DeclineSecretChatAccessRequestsRequest =
  Message<'com.gem.bff.contract.DeclineSecretChatAccessRequestsRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: repeated com.gem.bff.contract.DeclineSecretChatAccessRequestsRequest.UserDevice userDevice = 2;
     */
    userDevice: DeclineSecretChatAccessRequestsRequest_UserDevice[];
  };

/**
 * Describes the message com.gem.bff.contract.DeclineSecretChatAccessRequestsRequest.
 * Use `create(DeclineSecretChatAccessRequestsRequestSchema)` to create a new message.
 */
export const DeclineSecretChatAccessRequestsRequestSchema: GenMessage<DeclineSecretChatAccessRequestsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 8);

/**
 * @generated from message com.gem.bff.contract.DeclineSecretChatAccessRequestsRequest.UserDevice
 */
export type DeclineSecretChatAccessRequestsRequest_UserDevice =
  Message<'com.gem.bff.contract.DeclineSecretChatAccessRequestsRequest.UserDevice'> & {
    /**
     * @generated from field: int64 userId = 1;
     */
    userId: bigint;

    /**
     * @generated from field: string deviceId = 2;
     */
    deviceId: string;
  };

/**
 * Describes the message com.gem.bff.contract.DeclineSecretChatAccessRequestsRequest.UserDevice.
 * Use `create(DeclineSecretChatAccessRequestsRequest_UserDeviceSchema)` to create a new message.
 */
export const DeclineSecretChatAccessRequestsRequest_UserDeviceSchema: GenMessage<DeclineSecretChatAccessRequestsRequest_UserDevice> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 8, 0);

/**
 * @generated from message com.gem.bff.contract.UpdateChatRequest
 */
export type UpdateChatRequest = Message<'com.gem.bff.contract.UpdateChatRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional com.gem.bff.contract.Chat.Type type = 4;
   */
  type?: Chat_Type;

  /**
   * @generated from field: optional string avatarUrl = 5;
   */
  avatarUrl?: string;
};

/**
 * Describes the message com.gem.bff.contract.UpdateChatRequest.
 * Use `create(UpdateChatRequestSchema)` to create a new message.
 */
export const UpdateChatRequestSchema: GenMessage<UpdateChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 9);

/**
 * @generated from message com.gem.bff.contract.RemoveChatRequest
 */
export type RemoveChatRequest = Message<'com.gem.bff.contract.RemoveChatRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.RemoveChatRequest.
 * Use `create(RemoveChatRequestSchema)` to create a new message.
 */
export const RemoveChatRequestSchema: GenMessage<RemoveChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 10);

/**
 * @generated from message com.gem.bff.contract.AddChatParticipantsRequest
 */
export type AddChatParticipantsRequest =
  Message<'com.gem.bff.contract.AddChatParticipantsRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: repeated int64 userIds = 2;
     */
    userIds: bigint[];
  };

/**
 * Describes the message com.gem.bff.contract.AddChatParticipantsRequest.
 * Use `create(AddChatParticipantsRequestSchema)` to create a new message.
 */
export const AddChatParticipantsRequestSchema: GenMessage<AddChatParticipantsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 11);

/**
 * @generated from message com.gem.bff.contract.AddSecretChatParticipantsRequest
 */
export type AddSecretChatParticipantsRequest =
  Message<'com.gem.bff.contract.AddSecretChatParticipantsRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: repeated com.gem.bff.contract.E2eeAddParticipant participants = 2;
     */
    participants: E2eeAddParticipant[];

    /**
     * @generated from field: com.gem.bff.contract.E2eeCommit commit = 3;
     */
    commit?: E2eeCommit;
  };

/**
 * Describes the message com.gem.bff.contract.AddSecretChatParticipantsRequest.
 * Use `create(AddSecretChatParticipantsRequestSchema)` to create a new message.
 */
export const AddSecretChatParticipantsRequestSchema: GenMessage<AddSecretChatParticipantsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 12);

/**
 * @generated from message com.gem.bff.contract.AddChatAdminsRequest
 */
export type AddChatAdminsRequest = Message<'com.gem.bff.contract.AddChatAdminsRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: repeated int64 userIds = 2;
   */
  userIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.AddChatAdminsRequest.
 * Use `create(AddChatAdminsRequestSchema)` to create a new message.
 */
export const AddChatAdminsRequestSchema: GenMessage<AddChatAdminsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 13);

/**
 * @generated from message com.gem.bff.contract.RemoveChatParticipantsRequest
 */
export type RemoveChatParticipantsRequest =
  Message<'com.gem.bff.contract.RemoveChatParticipantsRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: repeated int64 userIds = 2;
     */
    userIds: bigint[];
  };

/**
 * Describes the message com.gem.bff.contract.RemoveChatParticipantsRequest.
 * Use `create(RemoveChatParticipantsRequestSchema)` to create a new message.
 */
export const RemoveChatParticipantsRequestSchema: GenMessage<RemoveChatParticipantsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 14);

/**
 * @generated from message com.gem.bff.contract.RemoveSecretChatParticipantsRequest
 */
export type RemoveSecretChatParticipantsRequest =
  Message<'com.gem.bff.contract.RemoveSecretChatParticipantsRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: repeated int64 userIds = 2;
     */
    userIds: bigint[];

    /**
     * @generated from field: com.gem.bff.contract.E2eeCommit commit = 3;
     */
    commit?: E2eeCommit;
  };

/**
 * Describes the message com.gem.bff.contract.RemoveSecretChatParticipantsRequest.
 * Use `create(RemoveSecretChatParticipantsRequestSchema)` to create a new message.
 */
export const RemoveSecretChatParticipantsRequestSchema: GenMessage<RemoveSecretChatParticipantsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 15);

/**
 * @generated from message com.gem.bff.contract.RevokeChatAdminsRequest
 */
export type RevokeChatAdminsRequest = Message<'com.gem.bff.contract.RevokeChatAdminsRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: repeated int64 userIds = 2;
   */
  userIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.RevokeChatAdminsRequest.
 * Use `create(RevokeChatAdminsRequestSchema)` to create a new message.
 */
export const RevokeChatAdminsRequestSchema: GenMessage<RevokeChatAdminsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 16);

/**
 * @generated from message com.gem.bff.contract.TransferOwnershipRequest
 */
export type TransferOwnershipRequest = Message<'com.gem.bff.contract.TransferOwnershipRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 newOwnerId = 2;
   */
  newOwnerId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.TransferOwnershipRequest.
 * Use `create(TransferOwnershipRequestSchema)` to create a new message.
 */
export const TransferOwnershipRequestSchema: GenMessage<TransferOwnershipRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 17);

/**
 * @generated from message com.gem.bff.contract.LeaveChatRequest
 */
export type LeaveChatRequest = Message<'com.gem.bff.contract.LeaveChatRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.LeaveChatRequest.
 * Use `create(LeaveChatRequestSchema)` to create a new message.
 */
export const LeaveChatRequestSchema: GenMessage<LeaveChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 18);

/**
 * @generated from message com.gem.bff.contract.JoinChatRequest
 */
export type JoinChatRequest = Message<'com.gem.bff.contract.JoinChatRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.JoinChatRequest.
 * Use `create(JoinChatRequestSchema)` to create a new message.
 */
export const JoinChatRequestSchema: GenMessage<JoinChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 19);

/**
 * @generated from message com.gem.bff.contract.ConfirmReadChatMessagesRequest
 */
export type ConfirmReadChatMessagesRequest =
  Message<'com.gem.bff.contract.ConfirmReadChatMessagesRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.ConfirmReadChatMessagesRequest.
 * Use `create(ConfirmReadChatMessagesRequestSchema)` to create a new message.
 */
export const ConfirmReadChatMessagesRequestSchema: GenMessage<ConfirmReadChatMessagesRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 20);

/**
 * @generated from message com.gem.bff.contract.UnpinAllMessagesRequest
 */
export type UnpinAllMessagesRequest = Message<'com.gem.bff.contract.UnpinAllMessagesRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.UnpinAllMessagesRequest.
 * Use `create(UnpinAllMessagesRequestSchema)` to create a new message.
 */
export const UnpinAllMessagesRequestSchema: GenMessage<UnpinAllMessagesRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 21);

/**
 * @generated from message com.gem.bff.contract.UnpinMessagesRequest
 */
export type UnpinMessagesRequest = Message<'com.gem.bff.contract.UnpinMessagesRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: repeated int64 messageIds = 2;
   */
  messageIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.UnpinMessagesRequest.
 * Use `create(UnpinMessagesRequestSchema)` to create a new message.
 */
export const UnpinMessagesRequestSchema: GenMessage<UnpinMessagesRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 22);

/**
 * @generated from message com.gem.bff.contract.PinMessagesRequest
 */
export type PinMessagesRequest = Message<'com.gem.bff.contract.PinMessagesRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: repeated int64 messageIds = 2;
   */
  messageIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.PinMessagesRequest.
 * Use `create(PinMessagesRequestSchema)` to create a new message.
 */
export const PinMessagesRequestSchema: GenMessage<PinMessagesRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 23);

/**
 * @generated from message com.gem.bff.contract.GetPinnedChatsRequest
 */
export type GetPinnedChatsRequest = Message<'com.gem.bff.contract.GetPinnedChatsRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetPinnedChatsRequest.
 * Use `create(GetPinnedChatsRequestSchema)` to create a new message.
 */
export const GetPinnedChatsRequestSchema: GenMessage<GetPinnedChatsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 24);

/**
 * @generated from message com.gem.bff.contract.PinChatRequest
 */
export type PinChatRequest = Message<'com.gem.bff.contract.PinChatRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.PinChatRequest.
 * Use `create(PinChatRequestSchema)` to create a new message.
 */
export const PinChatRequestSchema: GenMessage<PinChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 25);

/**
 * @generated from message com.gem.bff.contract.UnpinChatRequest
 */
export type UnpinChatRequest = Message<'com.gem.bff.contract.UnpinChatRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.UnpinChatRequest.
 * Use `create(UnpinChatRequestSchema)` to create a new message.
 */
export const UnpinChatRequestSchema: GenMessage<UnpinChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 26);

/**
 * @generated from message com.gem.bff.contract.ClearChatHistoryForMeRequest
 */
export type ClearChatHistoryForMeRequest =
  Message<'com.gem.bff.contract.ClearChatHistoryForMeRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.ClearChatHistoryForMeRequest.
 * Use `create(ClearChatHistoryForMeRequestSchema)` to create a new message.
 */
export const ClearChatHistoryForMeRequestSchema: GenMessage<ClearChatHistoryForMeRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 27);

/**
 * @generated from message com.gem.bff.contract.ClearChatHistoryForAllRequest
 */
export type ClearChatHistoryForAllRequest =
  Message<'com.gem.bff.contract.ClearChatHistoryForAllRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.ClearChatHistoryForAllRequest.
 * Use `create(ClearChatHistoryForAllRequestSchema)` to create a new message.
 */
export const ClearChatHistoryForAllRequestSchema: GenMessage<ClearChatHistoryForAllRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 28);

/**
 * @generated from message com.gem.bff.contract.MuteChatRequest
 */
export type MuteChatRequest = Message<'com.gem.bff.contract.MuteChatRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: bool muted = 2;
   */
  muted: boolean;
};

/**
 * Describes the message com.gem.bff.contract.MuteChatRequest.
 * Use `create(MuteChatRequestSchema)` to create a new message.
 */
export const MuteChatRequestSchema: GenMessage<MuteChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 29);

/**
 * @generated from message com.gem.bff.contract.GetChatUsersRequest
 */
export type GetChatUsersRequest = Message<'com.gem.bff.contract.GetChatUsersRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message com.gem.bff.contract.GetChatUsersRequest.
 * Use `create(GetChatUsersRequestSchema)` to create a new message.
 */
export const GetChatUsersRequestSchema: GenMessage<GetChatUsersRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 30);

/**
 * @generated from message com.gem.bff.contract.SearchUsersAddToChatRequest
 */
export type SearchUsersAddToChatRequest =
  Message<'com.gem.bff.contract.SearchUsersAddToChatRequest'> & {
    /**
     * @generated from field: optional int64 chatId = 1;
     */
    chatId?: bigint;

    /**
     * @generated from field: string query = 2;
     */
    query: string;

    /**
     * @generated from field: optional string cursor = 3;
     */
    cursor?: string;

    /**
     * @generated from field: optional int32 limit = 4;
     */
    limit?: number;
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersAddToChatRequest.
 * Use `create(SearchUsersAddToChatRequestSchema)` to create a new message.
 */
export const SearchUsersAddToChatRequestSchema: GenMessage<SearchUsersAddToChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 31);

/**
 * @generated from message com.gem.bff.contract.SearchUsersInChatRequest
 */
export type SearchUsersInChatRequest = Message<'com.gem.bff.contract.SearchUsersInChatRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * @generated from field: optional string cursor = 3;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message com.gem.bff.contract.SearchUsersInChatRequest.
 * Use `create(SearchUsersInChatRequestSchema)` to create a new message.
 */
export const SearchUsersInChatRequestSchema: GenMessage<SearchUsersInChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 32);

/**
 * @generated from message com.gem.bff.contract.SearchUsersForMentionRequest
 */
export type SearchUsersForMentionRequest =
  Message<'com.gem.bff.contract.SearchUsersForMentionRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: string query = 2;
     */
    query: string;

    /**
     * @generated from field: optional string cursor = 3;
     */
    cursor?: string;

    /**
     * @generated from field: optional int32 limit = 4;
     */
    limit?: number;
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersForMentionRequest.
 * Use `create(SearchUsersForMentionRequestSchema)` to create a new message.
 */
export const SearchUsersForMentionRequestSchema: GenMessage<SearchUsersForMentionRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 33);

/**
 * @generated from message com.gem.bff.contract.GetChatEventsRequest
 */
export type GetChatEventsRequest = Message<'com.gem.bff.contract.GetChatEventsRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: optional int64 cursorTs = 2;
   */
  cursorTs?: bigint;

  /**
   * @generated from field: optional int32 count = 3;
   */
  count?: number;
};

/**
 * Describes the message com.gem.bff.contract.GetChatEventsRequest.
 * Use `create(GetChatEventsRequestSchema)` to create a new message.
 */
export const GetChatEventsRequestSchema: GenMessage<GetChatEventsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 34);

/**
 * @generated from message com.gem.bff.contract.GetMultipleChatsEventsRequest
 */
export type GetMultipleChatsEventsRequest =
  Message<'com.gem.bff.contract.GetMultipleChatsEventsRequest'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.GetChatEventsRequest chats = 1;
     */
    chats: GetChatEventsRequest[];
  };

/**
 * Describes the message com.gem.bff.contract.GetMultipleChatsEventsRequest.
 * Use `create(GetMultipleChatsEventsRequestSchema)` to create a new message.
 */
export const GetMultipleChatsEventsRequestSchema: GenMessage<GetMultipleChatsEventsRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 35);

/**
 * @generated from message com.gem.bff.contract.GetUsersAddToChatRequest
 */
export type GetUsersAddToChatRequest = Message<'com.gem.bff.contract.GetUsersAddToChatRequest'> & {
  /**
   * @generated from field: optional int64 chatId = 1;
   */
  chatId?: bigint;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message com.gem.bff.contract.GetUsersAddToChatRequest.
 * Use `create(GetUsersAddToChatRequestSchema)` to create a new message.
 */
export const GetUsersAddToChatRequestSchema: GenMessage<GetUsersAddToChatRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 36);

/**
 * @generated from message com.gem.bff.contract.MarkChatsAsUnreadRequest
 */
export type MarkChatsAsUnreadRequest = Message<'com.gem.bff.contract.MarkChatsAsUnreadRequest'> & {
  /**
   * @generated from field: repeated int64 chatIds = 1;
   */
  chatIds: bigint[];

  /**
   * @generated from field: bool unread = 2;
   */
  unread: boolean;
};

/**
 * Describes the message com.gem.bff.contract.MarkChatsAsUnreadRequest.
 * Use `create(MarkChatsAsUnreadRequestSchema)` to create a new message.
 */
export const MarkChatsAsUnreadRequestSchema: GenMessage<MarkChatsAsUnreadRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 37);

/**
 * @generated from message com.gem.bff.contract.SetChatMessagesHistoryTtlRequest
 */
export type SetChatMessagesHistoryTtlRequest =
  Message<'com.gem.bff.contract.SetChatMessagesHistoryTtlRequest'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: optional int64 periodMs = 2;
     */
    periodMs?: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.SetChatMessagesHistoryTtlRequest.
 * Use `create(SetChatMessagesHistoryTtlRequestSchema)` to create a new message.
 */
export const SetChatMessagesHistoryTtlRequestSchema: GenMessage<SetChatMessagesHistoryTtlRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 38);

/**
 * @generated from message com.gem.bff.contract.CreateE2eeCommitRequest
 */
export type CreateE2eeCommitRequest = Message<'com.gem.bff.contract.CreateE2eeCommitRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: com.gem.bff.contract.E2eeCommit commit = 2;
   */
  commit?: E2eeCommit;

  /**
   * @generated from field: repeated com.gem.bff.contract.E2eeAddParticipant participants = 3;
   */
  participants: E2eeAddParticipant[];
};

/**
 * Describes the message com.gem.bff.contract.CreateE2eeCommitRequest.
 * Use `create(CreateE2eeCommitRequestSchema)` to create a new message.
 */
export const CreateE2eeCommitRequestSchema: GenMessage<CreateE2eeCommitRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_requests, 39);
